import { useEffect } from "react";
import { Footer } from "@/components/landing/Footer";
import { PRIVACY_INTRO, PRIVACY_SECTIONS, PRIVACY_UPDATED } from "@/data/privacy";

const Block = ({ text }) => (
  <p className="whitespace-pre-line text-sm leading-relaxed text-[#B8B8B8] sm:text-base">
    {text}
  </p>
);

const BulletList = ({ items }) => (
  <ul className="list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-[#B8B8B8] sm:text-base">
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ul>
);

export default function PrivacyPolicyPage() {
  useEffect(() => {
    document.title = "Privacy Policy | Tempio Vivo";
  }, []);

  return (
    <main data-testid="privacy-page" className="min-h-screen bg-[#080808]">
      <div className="mx-auto max-w-3xl px-6 py-20 lg:px-8">
        <a
          data-testid="privacy-home-link"
          href="/"
          className="text-xs uppercase tracking-widest text-[#8F7138] underline-offset-4 transition-colors hover:text-[#C9A45C] hover:underline"
        >
          ← Torna alla pagina principale
        </a>
        <p className="mt-10 text-xs font-bold uppercase tracking-[0.35em] text-[#C9A45C]">
          Tempio Vivo — Fede &amp; Fitness Italia
        </p>
        <h1 className="font-display mt-4 text-4xl font-semibold text-white sm:text-5xl">
          Privacy Policy
        </h1>
        <p className="mt-3 text-sm text-[#8F7138]">
          Ultimo aggiornamento: {PRIVACY_UPDATED}
        </p>
        <div className="mt-8 space-y-4">
          {PRIVACY_INTRO.map((p) => (
            <Block key={p.slice(0, 40)} text={p} />
          ))}
        </div>
        <div className="mt-12 space-y-10">
          {PRIVACY_SECTIONS.map((section) => (
            <section key={section.title} data-testid="privacy-section">
              <h2 className="font-display text-xl font-semibold uppercase tracking-wide text-[#C9A45C]">
                {section.title}
              </h2>
              <div className="mt-4 space-y-4">
                {section.blocks?.map((b) => (
                  <Block key={b.slice(0, 40)} text={b} />
                ))}
                {section.list && <BulletList items={section.list} />}
                {section.blocksAfter?.map((b) => (
                  <Block key={b.slice(0, 40)} text={b} />
                ))}
                {section.listAfter && <BulletList items={section.listAfter} />}
                {section.blocksFinal?.map((b) => (
                  <Block key={b.slice(0, 40)} text={b} />
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
      <Footer />
    </main>
  );
}
